import {HEELIX_URL} from '../../constants';

const forgotPassword = `<a href="${HEELIX_URL + '/#/password/new'}" class="text-center forgot-password-link">Forgot your password?</a>`;
export default forgotPassword;
